import API from "@/services/API"
import BackendRoute from "@/services/BackendRoute";
const api = API();
export const customBrandingUpdate = async function ({branding_workspace_name,branding_primary_color_font_inverse, branding_secondary_color_font_inverse, branding_primary_color, branding_secondary_color, branding_logo, branding_favicon}) {
    try {
        let routeUrl = BackendRoute.routeWithoutApiPrefix('settings.store');
        let response = await api.post(routeUrl, { branding_workspace_name, branding_primary_color_font_inverse, branding_secondary_color_font_inverse, branding_primary_color, branding_secondary_color, branding_logo, branding_favicon }, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });

        if (response?.data) {
            return { response: response.data, status: true };
        }

        return { response: response, status: true };

    } catch (error) {
        return { response: error.response.data, status: false };
    }
}